<kiwi-product-market-shares [marketShares]="study"></kiwi-product-market-shares>
